var _g, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeechatIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 370,
    viewBox: "0 0 370 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5645_1492)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 181,
    r: 181,
    fill: "#FFA153"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 181,
    r: 176,
    stroke: "#FFA153",
    strokeWidth: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.107 108.506L181.863 94.8987H188.886L191.081 108.506H180.107Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.83 290.08V267.447C161.83 266.342 162.726 265.447 163.83 265.447H223.649C225.872 265.447 226.436 268.53 224.356 269.317L164.538 291.951C163.23 292.446 161.83 291.479 161.83 290.08Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 160.304,
    width: 54.4312,
    height: 66.7222,
    rx: 27.2156,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 242.439,
    y: 160.304,
    width: 54.4312,
    height: 66.7222,
    rx: 27.2156,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5584,
    y: 116.408,
    width: 188.753,
    height: 154.514,
    rx: 70,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108.995,
    y: 139.234,
    width: 151.003,
    height: 107.985,
    rx: 53,
    fill: "#FFA153"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 212.59,
    y: 108.507,
    width: 21.9481,
    height: 53.5533,
    rx: 10.974,
    transform: "rotate(90 212.59 108.507)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185.374,
    cy: 82.1688,
    r: 13.1688,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 142.356,
    y: 176.984,
    width: 21.0702,
    height: 32.4832,
    rx: 10.5351,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 206.444,
    y: 176.984,
    width: 21.0702,
    height: 32.4832,
    rx: 10.5351,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5645_1492",
    x: 0,
    y: 0,
    width: 370,
    height: 370,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5645_1492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5645_1492",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeechatIcon1);
export default __webpack_public_path__ + "static/media/Veechat_icon 1.f1a459e5dcde44b52fc8971d53e6403d.svg";
export { ForwardRef as ReactComponent };